const reduce = window.matchMedia("(prefers-reduced-motion: reduce)");

function focusPaintedErrors() {
  const box = document.getElementById("fejlboks");
  const painted = document.querySelectorAll(".page-contact__field.is-error");
  if (box && !box.hidden) {
    box.focus();
    return;
  }
  if (painted.length > 1) {
    if (box) {
      box.hidden = false;
      box.focus();
    }
    return;
  }
  if (painted.length === 1) {
    painted[0].querySelector("input, select, textarea")?.focus();
  }
}

const success = document.getElementById("succes");
if (success) {
  window.setTimeout(() => success.focus(), reduce.matches ? 0 : 200);
} else {
  focusPaintedErrors();
}

const form = document.getElementById("ContactForm");
const topic = document.getElementById("f-emne");
if (form && topic) {
  const name = document.getElementById("f-navn");
  const mail = document.getElementById("f-mail");
  const order = document.getElementById("f-ordre");
  const body = document.getElementById("f-tekst");
  const box = document.getElementById("fejlboks");
  const submit = form.querySelector(".page-contact__submit");
  const fields = {
    topic: { input: topic, error: document.getElementById("e-emne"), wrap: topic.closest(".page-contact__field"), summary: box?.querySelector("[data-summary='topic']") },
    name: { input: name, error: document.getElementById("e-navn"), wrap: name.closest(".page-contact__field"), summary: box?.querySelector("[data-summary='name']") },
    mail: { input: mail, error: document.getElementById("e-mail"), wrap: mail.closest(".page-contact__field"), summary: box?.querySelector("[data-summary='mail']") },
    order: { input: order, error: document.getElementById("e-ordre"), wrap: order.closest(".page-contact__field"), summary: box?.querySelector("[data-summary='order']") },
    body: { input: body, error: document.getElementById("e-tekst"), wrap: body.closest(".page-contact__field"), summary: box?.querySelector("[data-summary='body']") },
  };

  let submitting = false;

  form.setAttribute("novalidate", "");

  function topicKey() {
    return topic.selectedOptions[0]?.dataset.contactTopic || "";
  }

  function isDelivery() {
    return topicKey() === "delivery";
  }

  function syncOrderRequired() {
    const needed = isDelivery();
    order.toggleAttribute("required", needed);
    if (needed) order.setAttribute("aria-required", "true");
    else order.removeAttribute("aria-required");
  }

  function fieldOk(key) {
    if (key === "topic") return Boolean(topic.value);
    if (key === "name") return Boolean(name.value.trim());
    if (key === "mail") return /.+@.+\..+/.test(mail.value);
    if (key === "order") return !isDelivery() || Boolean(order.value.trim());
    if (key === "body") return Boolean(body.value.trim());
    return true;
  }

  function validate() {
    return ["topic", "name", "mail", "order", "body"].filter((key) => !fieldOk(key));
  }

  function setFieldError(key, on) {
    const field = fields[key];
    if (!field) return;
    field.wrap.classList.toggle("is-error", on);
    field.input.setAttribute("aria-invalid", on ? "true" : "false");
    if (on) field.input.setAttribute("aria-describedby", field.error.id);
    else field.input.removeAttribute("aria-describedby");
    field.error.hidden = !on;
    if (field.summary) field.summary.hidden = !on;
  }

  function showErrors(keys) {
    for (const key of Object.keys(fields)) setFieldError(key, keys.includes(key));
    if (!box) return;
    if (keys.length > 1) {
      box.hidden = false;
      box.focus();
    } else {
      box.hidden = true;
      if (keys.length === 1) fields[keys[0]]?.input.focus();
    }
  }

  function clearIfFixed(key) {
    if (!fields[key].wrap.classList.contains("is-error")) return;
    if (!fieldOk(key)) return;
    setFieldError(key, false);
    const open = validate();
    if (box && open.length < 2) box.hidden = true;
  }

  function setBusy(on) {
    submitting = on;
    submit.setAttribute("aria-disabled", on ? "true" : "false");
    submit.setAttribute("aria-busy", on ? "true" : "false");
    submit.textContent = on ? submit.dataset.labelBusy : submit.dataset.labelSubmit;
  }

  topic.addEventListener("change", () => {
    syncOrderRequired();
    clearIfFixed("topic");
    clearIfFixed("order");
  });
  name.addEventListener("input", () => clearIfFixed("name"));
  mail.addEventListener("input", () => clearIfFixed("mail"));
  order.addEventListener("input", () => clearIfFixed("order"));
  body.addEventListener("input", () => clearIfFixed("body"));

  form.addEventListener("submit", (event) => {
    if (submitting) {
      event.preventDefault();
      return;
    }
    const keys = validate();
    if (keys.length) {
      event.preventDefault();
      showErrors(keys);
      return;
    }
    setBusy(true);
  });

  syncOrderRequired();
}
